<template>
  <!--头部组件-->
  <tkui-header class="b-b-f" :class="{'header-border-bottom': borderShow}"  center>
    <div slot="left-menu" @click="handleGoBack">
      <tkui-button class="icon">
        <tk-icon size="16">{{icon}}</tk-icon>
      </tkui-button>
    </div>
    <!--插槽-->
    <slot></slot>
    <div slot="right-menu" class="m-r-15">
      <slot name="right-menu"></slot>
    </div>
  </tkui-header>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'return'
    },
    borderShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
    * 如果不绑定方法只执行返回操作
    * @date: 2020/3/9
    */
    handleGoBack () {
      this.$listeners.watchBack !== undefined ? this.$listeners.watchBack() : this.$back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .b-b-f{
    font-size: 16px;
  }
  .header-border-bottom {
    border-bottom: 1px solid #f5f5f5;
  }
</style>
